<template>
    <div class="beike-container">
        <div class="banner">
            <p>
                {{ companyConfig.firstName }}简介
            </p>

            <!-- <img :src="require('@/assets/imgs/aboutUs/banner_1.png')" alt="名盛房产"> -->
        </div>
        <!-- 主要内容容器 -->
        <div id="introductionContainer">
            <!-- 导航 -->
            <div class="navContainer" id="navContainer">
                <div class="subNav">
                    <div v-for="(nav, index) in navItems" :key="index" class="navItem"
                        :class="{ active: activeNav === index }" @click="scrollToSection(index)">
                        {{ nav }}
                    </div>
                </div>
            </div>

            <!-- 公司简介 -->
            <div class="corporateOverview" id="introduction_subContent_0" ref="section0">
                <div class="title">公司简介</div>
                <div class="aboutContent">
                    四川名盛房地产经纪有限公司，创立于2001年，系四川省房地产经纪机构一级资质企业（2010年获评）。公司总部位于乐山邦泰中心写字楼5楼整层，自购办公面积逾3000平方米。旗下业务覆盖乐山、峨眉、眉山、成都、重庆、上海6城，员工超1000人。
                    <div class="aboutContent2" style="margin-top: 20px;">
                        主营业务涵盖房地产经纪、咨询、评估、新房代理及租赁。伴随持续发展，公司已延伸拓展至市场营销策划、广告设计、家具家电销售、税务服务、软件开发等多个领域，致力于构建综合性人居服务平台。
                    </div>
                </div>
            </div>

            <!-- 愿景与使命 -->
            <div class="visionContainer" id="introduction_subContent_1" ref="section1">
                <div class="visionMission">
                    <div class="title">愿景及使命</div>
                    <div class="visionContent">
                        <div class="contentItem">
                            <div class="itemTitle">我们的愿景</div>
                            <div class="itemDesc">成为四川省房地产经纪品牌的领先者</div>
                        </div>
                        <div class="contentItem">
                            <div class="itemTitle">我们的使命</div>
                            <div class="itemDesc">引领行业健康、规范发展|提供安全快捷、方便舒适的消费体验|为员工搭建实现个人梦想的舞台</div>
                        </div>
                        <div class="contentItem">
                            <div class="itemTitle">我们的价值观</div>
                            <div class="itemDesc">共赢、尊重、开放、真诚、激情、敬业</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 发展历程 -->
            <div class="developContainer" id="introduction_subContent_2" ref="section2">
                <div class="timeListContainer">
                    <div class="title">发展历程</div>
                    <img :src="require('@/assets/imgs/aboutUs/history.png')" alt="">
                </div>
            </div>
            <div style="height: 100px;"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: 'BeikeIntroduction',
    data() {
        return {
            activeNav: 0,
            activeTime: 0,
            developLeft: 0,
            navItems: [
                '公司简介',
                '愿景与使命',
                '发展历程',
            ],
        };
    },
    computed: {
        ...mapState(["companyConfig"])
    },
    created() {
        this.activeNav = Number(this.$route.params.type);
    },
    methods: {
        scrollToSection(index) {
            this.activeNav = index;
            const sectionId = `introduction_subContent_${index}`;
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        },
        changeTime(index) {
            this.activeTime = index;
        },
        handleScroll() {
            // 监听滚动，更新激活的导航项
            const sections = ['section0', 'section1', 'section2'];
            for (let i = 0; i < sections.length; i++) {
                const ref = this.$refs[sections[i]];
                if (ref) {
                    const rect = ref.getBoundingClientRect();
                    if (rect.top <= 100 && rect.bottom >= 100) {
                        this.activeNav = i;
                        break;
                    }
                }
            }
        }
    },
    mounted() {
        // 添加滚动监听
        window.addEventListener('scroll', this.handleScroll);
        this.$nectTick(() => {
            this.scrollToSection(this.activeNav)
        })
    },
    beforeDestroy() {
        // 移除滚动监听
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style scoped>
/* 这里需要从原始HTML中提取CSS样式 */
/* 由于CSS内容非常多，这里只写关键样式，完整的CSS需要从原始页面提取 */

.beike-container {
    font-size: 18px;
}

.banner {
    height: 400px;
    width: 100%;
    background-image: url('~@/assets/imgs/aboutUs/banner_2.jpeg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;

    p {
        font-size: 44px;
        color: #fff;
        letter-spacing: 2px;
        position: absolute;
        bottom: 170px;
        left: 360px;
    }

    img {
        height: 400px;
        /* width: 100%; */
    }
}

.wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.btns {
    display: flex;
    align-items: center;
    height: 80px;
}


.navContainer {
    width: 100%;
    background: #f8f9fa;
    position: sticky;
    top: 0px;
    z-index: 999;
}

.subNav {
    width: 800px;
    display: flex;
    margin: 0 auto;
    font-family: HiraginoSansGB-W3;
    color: #222;
    letter-spacing: 0;
}

.navItem {
    height: 64px;
    line-height: 64px;
    padding: 0 10px;
    min-width: 76px;
    position: relative;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    white-space: nowrap;
    margin-right: 64px;
    transition: color 0.3s;
}

.navItem.active {
    position: relative;
}

.subNav .navItem.active:after {
    content: "";
    width: 24px;
    height: 3px;
    display: block;
    background: #1a66ff;
    border-radius: 8px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
}

.corporateOverview {
    width: 800px;
    margin: 0 auto;
}


.title {
    margin-top: 120px;
    margin-bottom: 40px;
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    color: #222;
    letter-spacing: 0;
    line-height: 48px;
}

.aboutContent {
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
    /* text-align: center; */
    color: #333;
}

.visionContainer {
    width: 800px;
    margin: 0 auto;
}

.visionContent {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    gap: 60px;
    margin: 40px auto;
    width: 800px;
    text-align: left;
}

.contentItem {
    flex: 1;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        right: -10px;
        top: 0;
        height: 60px;
        width: 1px;
        background: #ddd;

    }
}

.contentItem:last-child {
    &::after {
        content: none;
    }
}

.itemTitle {
    font-size: 24px;
    color: #222;
    line-height: 32px;
    margin-bottom: 10px;

}

.itemDesc {
    font-size: 18px;
    color: #222;
    line-height: 26px;
}

.developContainer {
    width: 800px;
    margin: 0 auto;

    .timeListContainer {
        img {
            width: 100%;
            height: auto;
        }
    }
}









/* 响应式设计 */
@media (min-width: 1080px) {
    .subNav {
        flex-wrap: wrap;
        gap: 10px;
    }

    .visionContent {
        width: 1200px;
    }

    .manageItem {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .textContainer {
        margin-left: 0;
        margin-top: 20px;
    }

    .texts {
        flex-direction: column;
        gap: 30px;
    }

    .officeContainer .content {
        flex-direction: column;
    }

    .subNav {
        width: 1200px;
    }

    .corporateOverview {
        width: 1200px;
    }

    .aboutContent {
        max-width: 1200px;
    }

    .visionContainer {
        width: 1200px;
    }

    .developContainer {
        width: 1200px;
    }

}
</style>